import { applyHiddenModules } from './hiddenModules';

/**
 * Which top menu entries a user sees. Kept out of MegaMenuInner so it can be
 * tested without rendering. OL-210: Tasks (/reminders) sat in MENU_MEGA but
 * MegaMenuInner never picked it, so the page had no menu entry.
 */

const lower = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');

const allowed = (ability, item) =>
  !item.permission || ability.can(item.permission.action, item.permission.subject);

const filterChildren = (children = [], ability) =>
  children
    .map((child) => {
      if (child.children && child.children.length > 0) {
        const filtered = filterChildren(child.children, ability);
        return filtered.length > 0 || child.path ? { ...child, children: filtered } : null;
      }

      return allowed(ability, child) ? child : null;
    })
    .filter(Boolean);

/**
 * The menu without the firm's hidden modules (OL-135) and without the links
 * the user may not open. A group stays while it has any link left.
 */
export const filterMenuItems = (items, ability, hiddenKeys = []) =>
  applyHiddenModules(
    items.map((section) => ({
      ...section,
      children: section.children?.map((child) => ({ ...child })) ?? [],
    })),
    hiddenKeys
  )
    .map((item) => (item?.children?.length ? { ...item, children: filterChildren(item.children, ability) } : item))
    .filter((item) => {
      if (item?.children?.length > 0) return true;
      return allowed(ability, item);
    });

/** The entries MegaMenuInner renders, each {} when the user can't see it. */
export const pickTopMenuItems = (items) => {
  const byTitle = (label) => items.find((item) => lower(item?.title) === label) || {};
  // Looked up by path, not title: the label is product copy and gets renamed,
  // which would silently drop the item from the nav.
  const byPath = (path) => items.find((item) => item?.path === path) || {};

  return {
    home: byTitle('home'),
    contacts: byTitle('contacts'),
    matters: byTitle('matters'),
    tasks: byPath('/reminders'),
    sharedStorage: byPath('/shared-storage'),
    documents: byTitle('documents'),
    billing: byTitle('billing'),
    referrals: byTitle('referrals'),
    reports: byTitle('reports'),
    marketing: byTitle('marketing'),
    basicSetup: byTitle('basic setup'),
  };
};
